// extracted by mini-css-extract-plugin
export default {"dialog":"update_dialog__bGBMu"};